<template>
  <div class="container mt-5">
    <div class="row">
      <div class="col">
        <div class="card">
          <div class="card-body">
            <div class="row mb-5">
              <div class="col">
                <h4>{{ 'attributes' | t }}</h4>
              </div>
              <div class="col d-flex">
                <button class="btn btn-lg btn-primary ml-auto" @click="open_modal()">{{ 'add_attribute' | t }}</button>
              </div>
            </div>
            <mail-builders-module-attribute
              class="mb-5"
              v-for="attribute_type in boolean_attribute_types"
              :key="attribute_type.id"
              :attribute_type="attribute_type"
              :active_locales="template_type.active_locales"
            ></mail-builders-module-attribute>
            <hr />
            <mail-builders-module-attribute
              class="mb-5"
              v-for="attribute_type in non_boolean_attribute_types"
              :key="attribute_type.id"
              :attribute_type="attribute_type"
              :active_locales="template_type.active_locales"
            ></mail-builders-module-attribute>
            <div class="col d-flex">
              <button class="btn btn-lg btn-primary ml-auto" @click="open_modal()">{{ 'add_attribute' | t }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <mail-builders-module-new-attribute-modal
      ref="add_attribute_modal"
      :template_type="template_type"
      @input="push_attribute($event)"
    ></mail-builders-module-new-attribute-modal>
  </div>
</template>
<script>
// @ts-check

export default {
  props: {
    template_type: {
      type: Object,
      required: true
    }
  },
  computed: {
    boolean_attribute_types() {
      return this.template_type.attribute_types.filter((x) => x.input_type === 'boolean');
    },
    non_boolean_attribute_types() {
      return this.template_type.attribute_types.filter((x) => x.input_type !== 'boolean');
    }
  },
  methods: {
    open_modal() {
      this.$refs.add_attribute_modal.open_modal();
    },
    push_attribute(event) {
      event.template_type_id = this.template_type.id;

      this.template_type.attribute_types.push(event);
    }
  }
};
</script>
